<template>
  <div v-if="webinarDate" class="c-webinar-date">
    <div class="c-webinar-divider"></div>
    <div :class="webinarIcon" />
    <div class="c-webinar-message">{{ webinarMessage() }}</div>
  </div>
  <template v-else></template>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-Webinar',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    webinarDate() {
      let timestamp = this.item.broadcastDate?.value;

      if (!timestamp) {
        return null;
      }

      const date = new Date(
        new Date(
          timestamp.replace(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(\w)?$/, '$1-$2-$3T$4:$5Z')
        )
      );

      if (isNaN(date)) {
        return null;
      }

      return date;
    },
    isUpcomingEvent() {
      const date = this.webinarDate;
      const currentDate = new Date();

      if (date && date.getTime() >= currentDate.getTime()) {
        // Event is today or in the future.
        return true;
      }

      return false;
    },
    webinarIcon() {
      if (this.isUpcomingEvent) {
        return 'c-webinar-icon c-webinar-icon-upcoming';
      } else if (this.item.showPostEventVideoIcon?.value) {
        return 'c-webinar-icon c-webinar-icon-recording';
      } else {
        return 'c-webinar-icon c-webinar-icon-past';
      }
    }
  },
  methods: {
    webinarMessage() {
      const date = this.webinarDate;

      if (isNaN(date)) {
        return '';
      }

      // use long month, numeric year and day, and use UTC so it isn't adjusted to local timezone, which can change the shown date.
      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
      };

      const dateString = date?.toLocaleDateString(undefined, dateOptions);

      if (!dateString) {
        return '';
      }

      const currentDate = new Date();

      if (date.getTime() < currentDate.getTime()) {
        // Event has already occurred.
        return this.item.postEventMessage?.value;
      } else {
        // Event is today or in the future.
        return this.item.preEventMessage?.value + ' ' + dateString.replaceAll(' ', '\u00A0');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-webinar-date {
  display: flex;
  align-items: flex-start;
}

.c-webinar-divider {
  display: none;
  width: 0.1rem;
  height: 2rem;
  background: url(~@/assets/images/divider.svg) no-repeat;
  margin-right: 1rem;

  @include large-desktop-up {
    display: inline-block;
  }
}

.c-webinar-icon {
  width: 2.4rem;
  height: 2.3rem;
  margin-right: 0.75rem;

  @media (max-width: 1308px) {
    padding-top: 0.25rem;
    padding-bottom: 1.25rem;
  }
}

.c-webinar-message {
  width: 100%;
  @include font-styles('Arial', 1.4rem, 500, normal, 1.8rem, 0, $dark-blue);
}

.c-webinar-icon-past {
  background: url(~@/assets/images/icon_past.svg) no-repeat;
}

.c-webinar-icon-recording {
  background: url(~@/assets/images/icon_recording.svg) no-repeat;
}

.c-webinar-icon-upcoming {
  background: url(~@/assets/images/icon_upcoming.svg) no-repeat;

  @include tablet-up {
    position: relative;
    top: -0.2rem;
  }
}
</style>
